import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminUtilityPage } from './admin-utility';
import { MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    AdminUtilityPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminUtilityPage),
    MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule
  ],
})
export class AdminUtilityPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-utility/admin-utility.module.ts